.recorder {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.startButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px;
  width: 100%;
  border: 1px dashed var(--dark-20);
  border-radius: 8px;
  background: none;
  cursor: pointer;
}

.startIcon {
  display: flex;
}

.recordingRow,
.recordedRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.meter {
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background: var(--dark-10);
  overflow: hidden;
}

.meterFill {
  display: block;
  height: 100%;
  background: var(--dark-90);
  transition: width 0.2s linear;
}

.uploading {
  display: flex;
  align-items: center;
  gap: 8px;
}

.linkButton {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
}

.linkButton:hover {
  text-decoration: underline;
}
